import _debounce from 'lodash/debounce';

export const asyncDebounce = (functionToDebounce, wait = 500) => {
    const debounced = _debounce((resolve, reject, args) => {
        functionToDebounce(...args)
            .then(resolve)
            .catch(reject);
    }, wait);
    return (...args) =>
        new Promise((resolve, reject) => {
            debounced(resolve, reject, args);
        });
};
